module.exports = __webpack_public_path__ + "img/jam-logo.png";